export default {
  companyName: "Logivery s.r.l.",
  vat: "IT10092301216",
  shareCapital: "16.666.83",
  businessRegistry: "NA - 1080218",
  sdi: "K95IV18",
  email: "info@logivery.com",
  certifiedEmail: "logivery@pec.it",
  officeAddress:
    "Via Masseria Grande, 31 - 80057 Sant'Antonio Abate (NA) - Italia",
  operationalAddress:
    "Via R. Passarelli 130 - 84078 Vallo della Lucania (SA) - Italia",
};
